<template>
  <div id="contenedor-excel-pagos">
    <v-form
      ref="exportarPagosExcel"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Pagos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="seleccion"
            mandatory>
            <v-radio
              value="listadoActual">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Listado Actual</strong>
                </div>
              </template>
            </v-radio>
            <v-radio
              value="rangoFechas">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Rango de Fechas</strong>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-row v-if="seleccion === 'rangoFechas'">
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row>
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="!formularioValido"
            :loading="estaCargando"
            @click="generarExcelPagos">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;
export default {
  name: 'ExcelPagos',
  mixins: [mixGenerarExceles],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
    listadoPagos: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomDatePicker,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      seleccion: 'listadoActual',
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'EXCEL PAGOS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
        border: {
          top: {
            style: 'medium',
            color: '000000',
          },
          bottom: {
            style: 'medium',
            color: '000000',
          },
        },
      },
      estilosGeneral: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        {
          value: 'Fecha', nombreColumna: 'fecha', orden: 0,
        },
        {
          value: 'Contrato', nombreColumna: 'contrato', orden: 1,
        },
        {
          value: 'Referencia', nombreColumna: 'referencia', orden: 2,
        },
        {
          value: 'Tipo', nombreColumna: 'tipo', orden: 3,
        },
        {
          value: 'Num. Est.', nombreColumna: 'numEst', orden: 4,
        },
        {
          value: 'Pagado', nombreColumna: 'pagado', orden: 5,
        },
        {
          value: 'Contratista', nombreColumna: 'contratista', orden: 6,
        },
      ],
      noData: [{
        fecha: '',
        contrato: '',
        referencia: '',
        tipo: '',
        numEst: '',
        pagado: '',
        contratista: '',
      }],
    };
  },
  methods: {
    async generarExcelPagos() {
      const data = this.crearExcelPagos;
      await this.mixGenerarExcel(data);
    },
    cerrar() {
      this.$refs.exportarPagosExcel.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
  },
  computed: {
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    getPagos() {
      if (!this.listadoPagos) return [];
      const listadoCompleto = this.listadoPagos
        .map((pago) => ({
          ...pago,
          detalles: pago.detalles.map((detalle) => {
            let programa = null;

            if (detalle.pagoSolicitudDetalle.anticipo) {
              programa = detalle
                .pagoSolicitudDetalle.anticipo.contrato.obras[0]?.obra.programa.nombre;
            }

            if (detalle.pagoSolicitudDetalle.estimacion) {
              programa = detalle
                .pagoSolicitudDetalle.estimacion.contrato.obras[0]?.obra.programa.nombre;
            }
            if (detalle.pagoSolicitudDetalle.escalatoria) {
              programa = detalle
                .pagoSolicitudDetalle.escalatoria.contrato.obras[0]?.obra.programa.nombre;
            }
            if (detalle.pagoSolicitudDetalle.gasto) {
              programa = detalle.pagoSolicitudDetalle.gasto.contrato.obras[0]?.obra.programa.nombre;
            }

            return {
              ...detalle,
              programa,
            };
          }),
        }));
      const listadoFiltrado = listadoCompleto
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .filter((pago) => {
          // Filtrar por ejercicio
          const fecha = new Date(`${pago.fecha} 00:00:0`);
          const ejercicio = fecha.getFullYear();

          return this.filtros.ejercicio === ejercicio;
        })
        .filter((pago) => {
          // Filtrar por proveedor
          if (!this.filtros.idContratista) return true;

          return this.filtros.idContratista === pago.idContratista;
        })
        .filter((pago) => {
          if (!this.filtros.buscarTexto) return true;

          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const referencia = this.$normalizacionTexto(pago.referencia);
          const contratista = this.$normalizacionTexto(pago.contratista.nombreRazonSocial);

          return (
            expt.test(pago.referencia)
            || expt.test(pago.contratista.nombreRazonSocial)
            || expt.test(referencia)
            || expt.test(contratista)
          );
        });
      return this.seleccion === 'listadoActual' ? listadoFiltrado : listadoCompleto;
    },
    getListadoPagosExcel() {
      const listadoPagosExcel = [];
      const listadoPagosExcelRangoFechas = [];
      this.getPagos.forEach((pago) => {
        pago.detalles.forEach((detalle) => {
          const datos = {
            fecha: {
              value: new Date(`${pago.fecha} 00:00:0`).toLocaleDateString(),
              estilo: {
                ...this.estilosGeneral.centrado,
              },
            },
            contrato: detalle.contrato.numero,
            referencia: {
              value: pago.referencia,
              estilo: {
                ...this.estilosGeneral.centrado,
              },
            },
            tipo: {
              value: detalle.tipo,
              estilo: {
                ...this.estilosGeneral.centrado,
              },
            },
            numEst: {
              value: detalle.tipo === 'Estimación' ? detalle.pagoSolicitudDetalle.estimacion.numero : '',
              estilo: {
                ...this.estilosGeneral.centrado,
              },
            },
            pagado: {
              value: detalle.importe,
              estilo: {
                numberFormat: '#,##0.00',
              },
            },
            contratista: pago.contratista.nombreRazonSocial,
          };
          listadoPagosExcel.push(datos);
          const isBetween = this.$moment(pago.fecha)
            .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');
          if (isBetween) {
            listadoPagosExcelRangoFechas.push(datos);
          }
        });
      });
      return this.seleccion === 'rangoFechas' ? listadoPagosExcelRangoFechas : listadoPagosExcel;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD-MM-YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD-MM-YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: 'CONSULTA DE PAGOS EFECTUADOS',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 7,
          },
        },
      );
      if (this.seleccion === 'rangoFechas') {
        datosDocumento.push(
          {
            value: `DEL ${inicial} AL ${final}`,
            row: 2,
            col: 1,
            estilo: {
              font: {
                size: 14,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            combinar: {
              row: 2,
              col: 7,
            },
          },
        );
      }
      return datosDocumento;
    },
    crearExcelPagos() {
      // const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getPagos.length > 0 ? this.getListadoPagosExcel : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
